<template>
  <div id="app">
    <!-- Header -->
    <div class="header">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <nav class="navbar navbar-expand-lg navbar-light">
              <router-link :to="{ name: 'home' }" class="navbar-brand">
                <img class="logo" src="/static/images/opnLogo.svg" />
                <img class="logo" style="margin-top:19px" src="/static/images/opnText.svg" />

              </router-link>

              <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>

              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item">
                    <router-link :to="{ name: 'home' }" class="nav-link">
                      Forside
                    </router-link>
                  </li>

                  <li class="nav-item">
                    <router-link :to="{ name: 'product' }" class="nav-link">
                      Produkt
                    </router-link>
                  </li>

                  <li class="nav-item" style="display:none">
                    <router-link :to="{ name: 'pricing' }" class="nav-link">
                      Pris
                    </router-link>
                  </li>

                  <li class="nav-item">
                    <a class="nav-link" href="https://app.opnx.dk">
                      Login
                    </a>
                  </li>
                </ul>

                <form class="form-inline">
                  <router-link :to="{ name: 'sign-up' }" class="btn btn-primary try-now"
                    >Prøv gratis nu</router-link
                  >
                </form>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="content">
      <router-view></router-view>
    </div>

    <!-- Footer -->
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-md-2 text-center">
            <img src="/static/images/footer-logo.svg" class="footerLogo"/><br />
          </div>

          <div class="col-md-3 centerMobile">
            <ul>
              <li class="headline">
                <span>Undersider</span>
              </li>

              <li>
                <router-link :to="{ name: 'home' }">Forside</router-link>
              </li>

              <li>
                <router-link :to="{ name: 'product' }">Produkt</router-link>
              </li>

              <li style="display:none">
                <router-link :to="{ name: 'pricing' }">Priser</router-link>
              </li>

              <li>
                <router-link :to="{ name: 'terms-of-service' }">
                  Handelsbetingelser
                </router-link>
              </li>

              <li>
                <router-link :to="{ name: 'privacy-policy' }">
                  Privatlivspolitik
                </router-link>
              </li>
            </ul>
          </div>

          <div class="col-md-3 centerMobile">
            <ul>
              <li class="headline">
                <span>Kontakt</span>
              </li>

              <li>
                <span>70 23 10 23</span>
              </li>

              <li>
                <span>info@generaxion.dk</span>
              </li>

              <li>
                <span>CVR: 31 18 98 10</span>
              </li>
            </ul>
            <div class="social-icons">
            <a
              href="https://www.facebook.com/generaxiondigital"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span class="fa fa-facebook fa-fw"></span>
            </a>
              <a
                href="https://www.instagram.com/generaxiondigital/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="fa fa-instagram fa-fw"></span>
              </a>
              <a
                href="https://dk.linkedin.com/company/generaxiondigital"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="fa fa-linkedin fa-fw"></span>
              </a>
            </div>
          </div>

          <div class="col-md-2 centerMobile">
            <ul>
              <li class="headline">
                <span>Find vej</span>
              </li>

              <li>
                <span>Aarhus</span>
              </li>

              <li>
                <span>Sommervej 23A</span>
              </li>

              <li>
                <span>8210 Aarhus V</span>
              </li>
            </ul>
          </div>
          <div class="col-md-2 centerMobile">
            <ul>
              <li class="headline hideMobile">
                <span>-</span>
              </li>

              <li>
                <span>København</span>
              </li>

              <li>
                <span>Ryesgade 106A</span>
              </li>

              <li>
                <span>2100 København</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style lang="scss">
@import url("~bootstrap/dist/css/bootstrap.css");
@import url("~font-awesome/css/font-awesome.css");

@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700");
@import "~bootstrap/scss/bootstrap.scss";

$navItemSpacing: 40px;

html,
body {
  height: 100%;
}

#app {
  height: 100%;
  display: flex;
  flex-direction: column;

  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //padding-top: 25px; //TODO: when TopNotificationBar is removed, add this padding!

  .header {
    nav {
      padding-left: 0;
      padding-right: 0;
      //margin-top:-15px; //TODO: when TopNotificationBar is removed, add this margin!
      z-index: 90;
      position: relative;
      background: #fff;

      .logo {
        width: 80px;
        margin-top: -12px;
        float: left;
      }
    }

    ul.navbar-nav {
      li {
        a {
          padding-left: $navItemSpacing;
          padding-right: $navItemSpacing;
        }
      }
    }

    .form-inline {
      margin-left: $navItemSpacing;
    }
  }

  @include media-breakpoint-down(md) {
    .navbar-collapse.collapse,
    .navbar-collapse.collapsing {
      ul {
        margin-top: 20px;

        li {
          border-bottom: 1px solid #ededed;

          &:first-child {
            border-top: 1px solid #ededed;
          }

          a {
            padding: 10px;
          }
        }
      }

      .form-inline {
        margin-left: 10px;
        position: relative;
        z-index: 99;

        a,
        button {
          width: 100%;
          margin-top: 10px;
        }
      }
    }
  }

  > .content {
    flex: 1 0 auto;
  }

  .try-now{
    background-color:#F1A1D9;
    border-color:#F1A1D9;
    position: relative;
    z-index: 99;
  }
  .try-now:hover{
  filter: brightness(0.90);
  }

  footer {
    color: #fff;
    width: 100%;
    background-color: #36434d;
    padding: 60px 0;

    .footerLogo{
    max-width: 130px
    }

    .social-icons {
      margin-top: 6px;
      font-size: 20px;
      margin-left:-6px;

      a {
        color: #90959a;
      }
    }

    ul {
      padding: 0;
      margin: 0;
      list-style: none;
      font-size: 11pt;

      li {
        padding: 7px 0;

        a {
          color: #fff;
        }

        span {
          color: #868e94;
        }

        &.headline {
          span {
            font-weight: 500;
          }
        }
      }
    }

    @include media-breakpoint-down(md) {
      ul {
        margin-bottom: 25px;
      }
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 400;
    line-height: 140%;
  }
  .showMobile{
  display:none;
  }
  @media screen and (max-width: 767px) {
  .centerMobile{
  text-align:center;
  }
  .hideMobile{
  display:none!important;
  }
  .showMobile{
  display:block;
  top:120px;
  width:100%;
  opacity:0.2;
  overflow:hidden;
  position:fixed;
  }
}
}
</style>

<script>
import { mapMutations } from "vuex";

require("bootstrap/dist/js/bootstrap.min.js");

export default {
  name: "app",
  watch: {
    $route() {
      window.scrollTo(0, 0);

      if ($(".navbar-collapse").hasClass("show")) {
        $(".navbar-toggler").click();
      }
    },
  },

  beforeMount() {
    this.checkForIdentity();
    this.checkForQueryParams();
  },

  methods: {
    ...mapMutations({
      setSource: "setSource",
    }),

    checkForIdentity() {
      const signedIn = this.$cookie.get("signedIn") !== null;

      if (!signedIn) {
        return;
      }

      window.location.href = "https://app.spotonlive.dk";
    },

    checkForQueryParams() {
      const route = this.$route;

      if (!route || !route.query) {
        return;
      }

      const query = route.query;

      if (query.utm_source) {
        this.setSource(query.utm_source);

        this.$router.replace({
          query: {},
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue